<template>
  <div class="page_salary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
            <el-form-item label="员工姓名" size="small">
              <el-input v-model="listQuery.EmployeeName" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" size="small">
              <el-input v-model="listQuery.CardId" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" size="small">
              <el-input v-model="listQuery.BankAccount" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
          </el-form>
          <!-- <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
        <!-- <el-button v-preventReClick type="success" size="small" @click="qqq" style="margin-right: 15px;">qqq</el-button> -->
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="发放途径" label-width="123px" size="small">
            <el-select v-model="listQuery.name" placeholder="" clearable filterable>
              <el-option value="银行"></el-option>
              <el-option value="灵活用工"></el-option>
              <el-option value="安心云"></el-option>
              <el-option value="现金"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送方式" label-width="94px" size="small">
            <el-select v-model="listQuery.name" placeholder="" clearable filterable>
              <el-option value="正常发送"></el-option>
              <el-option value="暂扣"></el-option>
              <el-option value="暂扣补发"></el-option>
              <el-option value="发送未成功补发"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/calcSalary' }">算薪</el-breadcrumb-item>
          <el-breadcrumb-item>明细</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div v-if="!isNull(baseInfo)">
          <div class="infoTitle">基本信息：
          </div>
          <div class="infoBox demandForm">
            <el-form :inline="true" label-width="110px">
              <el-form-item label="发薪编号:">{{baseInfo.PayrollNum}}</el-form-item>
              <div class="basicInfo flex aic">
                <el-form-item label="发薪项目:">
                  <div class="loongTxt" :title="baseInfo.ProjectName">
                    {{ baseInfo.ProjectName }}</div>
                </el-form-item>
                <el-form-item label="总应发金额:">{{baseInfo.TotalResponse ? baseInfo.TotalResponse.toFixed(2) : ''}}</el-form-item>
                <el-form-item label="总实发金额:">￥{{ baseInfo.GrandTotal ? baseInfo.GrandTotal.toFixed(2) : ''}}</el-form-item>
                <el-form-item label="发薪总人数:">{{baseInfo.TotalPayrolls}}</el-form-item>
                <el-form-item label="发放途径:">{{baseInfo.PayrollChannel}}</el-form-item>
                <el-form-item label="申请发薪日:">{{baseInfo.ApplicationDate}}</el-form-item>

                <div v-if="showBasicMore">
                  <el-form-item label="客户名称:">
                    <div class="loongTxt" :title="baseInfo.CustomerName">
                      {{ baseInfo.CustomerName }}</div>
                  </el-form-item>
                  <el-form-item label="商务合同主体:">
                    <div class="loongTxt" :title="baseInfo.Subject">
                      {{ baseInfo.Subject }}</div>
                  </el-form-item>
                  <el-form-item label="归属月:">{{baseInfo.AttrMonth}}</el-form-item>
                  <el-form-item label="申报月:">{{baseInfo.IncomeTaxMonth}}</el-form-item>
                  <el-form-item label="社保公积金:">{{baseInfo.AmountSocialSecurityFund}}</el-form-item>
                  <el-form-item label="专项扣除:">{{baseInfo.SpecialDeduction}}</el-form-item>
                  <el-form-item label="个税:">{{baseInfo.PersonalIncomeTax}}</el-form-item>
                  <el-form-item label="本月批次:">{{baseInfo.ThisMonthBatch}}</el-form-item>
                  <el-form-item label="个税申报类型:">{{baseInfo.IncomeTaxType}}</el-form-item>
                  <el-form-item label="" label-width="120px">
                    <div>
                      <el-checkbox v-model="baseInfo.PersonalTaxIsBorne" true-label="个税由个人承担" false-label="" disabled>个税由个人承担</el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item label="银行发放人数:">{{ }}</el-form-item>
                  <el-form-item label="银行实发:">{{ }}</el-form-item>
                  <el-form-item label="现金工资人数:">{{ }}</el-form-item>
                  <el-form-item label="现金工资金额:">{{ }}</el-form-item>
                  <el-form-item label="暂扣人数:">{{ }}</el-form-item>
                  <el-form-item label="暂扣:">{{ }}</el-form-item>
                  <el-form-item label="暂扣补发人数:">{{ }}</el-form-item>
                  <el-form-item label="暂扣补发:">{{ }}</el-form-item>
                  <div class="loongItem">
                    <el-form-item label="指定发放银行账户:" label-width="130px">{{ ApplySalaryExt.SpecifyBankAccount ? ApplySalaryExt.BankAccount : '-'}}</el-form-item>
                  </div>
                  <div class="loongItem">
                    <el-form-item label="申请备注:">{{ baseInfo.ApplyforRemark}}</el-form-item>
                  </div>
                  <div class="loongItem">
                    <el-form-item label="发薪摘要:">{{ baseInfo.PayrollSummary}}</el-form-item>
                  </div>
                  <div class="loongItem">
                    <el-form-item label="审批备注:">{{ baseInfo.ApprovalRemark}}</el-form-item>
                  </div>
                  <!-- <span>
                    <el-form-item label="商务合同主体：" label-width="120px">{{baseInfo.Subject}}</el-form-item>
                  </span> -->
                  <el-form-item label="导入表:"> <span v-if="baseInfo.PayScaleRul" @click="down(baseInfo.PayScaleRul)" class="down cp">下载</span></el-form-item>
                  <el-form-item label="客户原表:">
                    <div v-for="(item,index) in fileList2" :key="index" class="cp flex">
                      <div><i class="el-icon-document"></i></div>
                      <div class="cotName">{{item.name}}</div>
                      <div class="down" @click="down2(item.url,docHeadPath,item.name)">下载</div>
                    </div>
                  </el-form-item>

                </div>
              </div>
            </el-form>
          </div>
          <div class="showMore cp" @click="showBasicMore=!showBasicMore">
            <i :class="!showBasicMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:16px;"></i>
            {{ !showBasicMore ? '展开' : '收起' }}
          </div>
        </div>

        <div class="infoTitle incInfo">客户到款信息：
          <el-button type="text" size="small" @click="getPaymentInfo">
            <i :class="!showPayMore ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
            {{ !showPayMore ? '展开' : '收起' }}</el-button>
        </div>


        <div v-if="showPayMore" class="showPaymentInfo">
          <el-table :data="PaymentData" class="doc_table" style="width:100%;margin-bottom: 20px;">
            <el-table-column prop="PaymentNum" label="到款编号" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="TransactionSerialNumber" label="银行卡流水号" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankTransactionDate" label="到款时间" width="155" align="center">
              <template slot-scope={row}>
                {{ row.s2!=undefined && row.BankTransactionDate ? row.BankTransactionDate.replace('T',' ') : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="OppositeOpeningBank" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IncurredAmount" label="到款金额" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="UserEmainingAvailableCredit" :label="amountName" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProjectName" label="认领项目" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OppositeName" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateTime" label="认领时间" width="155" align="center">
              <template slot-scope={row}>
                {{ row.s2!=undefined && row.CreateTime ? row.CreateTime.replace('T',' ') : '' }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="算薪结果明细" name="0"></el-tab-pane>
          <el-tab-pane label="原始导入明细" name="1"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex" v-if="activeName=='0'">
          <el-button type="primary" size="small" @click="exportDtl" :loading="isExpLoading">导出工资单</el-button>
          <el-button type="warning" size="small" @click="exportTaxDtl" :loading="isTaxExpLoading">导出算税明细</el-button>
        </div>
        <div v-if="dtlType=='正常发薪'">
          <el-table :data="tableData" border class="doc_table" v-if="activeName=='0' && isOver" style="width:100%;">
            <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
              <template slot-scope="scope">
                {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
              </template>
            </el-table-column>
            <el-table-column prop="ApplicationDate" label="申请发放日期" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
              <template>{{baseInfo.ApplicationDate}}</template>
            </el-table-column>
            <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
              <template>{{baseInfo.ProjectName}} </template>
            </el-table-column>
            <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center" fixed="left">
            </el-table-column>
            <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankAccount" label="银行帐号" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
              <!-- <template>{{baseInfo.PayrollChannel}} </template> -->
            </el-table-column>
            <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">
              <!-- <template>{{baseInfo.PayType}} </template> -->
            </el-table-column>
            <!-- <el-table-column prop="SpecifyBankAccount" label="指定发放银行账户" width="125" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.SpecifyBankAccount == true ? '是' : row.SpecifyBankAccount == false ? '否' : '-' }}</template>
            </el-table-column> -->
            <el-table-column prop="RemitMode" label="发放通道" v-if="type=='部分发薪' || type=='发薪识别' " width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="Remark1" label="备注" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="IssuedThisMonth" label="本月实发" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IncludesTelephoneSubsidy" label="包含电话费补贴的税前应发" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OtherTaxDeductible" label="其中其他可避税项目" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CommunicationCharge" label="其中通讯费" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalSupport" label="个人承担养老" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalCare" label="个人承担医疗" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalUnemployment" label="个人承担失业" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BearCostSocialSecurity" label="个人承担社保费用" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ProvidentFundCosts" label="个人承担公积金费用" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IndividualIncomeTax" label="个人所得税" width="90" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AbourUnionFees" label="工会费" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DeductMealFee" label="扣餐费" width="80" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CompanyDeductRentUtilities" label="企业扣房租水电" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CompanyDeductsUtilities" label="公司扣房租水电" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OtherDeductions" label="其他扣款（税后）" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AdvanceWages" label="预支工资" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalAfterTaxDeductions" label="税后扣款合计" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DecimalPointBalance" label="小数点差额调整（默认为正数）" width="210" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TotalDeductible" label="扣除了所有费用的应扣合计" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth" label="当月历次发放工资金额首次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth2" label="当月历次发放工资金额二次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth3" label="当月历次发放工资金额三次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountSalaryPreviousMonth4" label="当月历次发放工资金额四次工资额" width="220" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ChildEducation" label="累计子女教育" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="ContinuingEducation" label="累计继续教育" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="HousingLoanInterest" label="累计住房贷款利息" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccumulatedHousingRent" label="累计住房租金" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="SupportElderlyCumulatively" label="累计赡养老人" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CumulativeInfantCareCosts" label="累计婴幼儿照护费用" width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccumulatedPersonalPension" label="累计个人养老金" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PhoneNum" label="手机号码" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="EmploymentDay" label="用工之日" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="DischargeDate" label="离职日期" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Remark1" label="打款备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PayrollCompany" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PersonalTaxIsBorne" label="税费承担方式" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="本年历月应税工资累计" width="155" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应纳税所得额" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应扣缴税额" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计已预缴税额" width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="累计应补(退)税额" width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="DebitMoney" label="未核销借支" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="name" label="其他调整" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" label="人员税局登记" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName==0">
            </el-table-column>
            <el-table-column prop="name" label="个税获取" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName==0">
            </el-table-column>
            <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="240px" v-if="activeName==0">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" @click="readInfo(row)">人员信息查看</el-button>
                  <el-button type="text" @click="editInfo(row)" v-if="baseInfo.ProcessState=='算薪'">人员信息修改</el-button>
                  <!-- <el-popconfirm title="请确定是否删除？" v-if="baseInfo.ProcessState=='算薪'" style="margin-left: 10px;" @confirm="del(row)">
                    <el-button type="text" slot="reference">删除</el-button>
                  </el-popconfirm> -->
                </div>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="activeName=='1'">
            <el-table :data="dtlData" border class="doc_table" style="width:100%;">
              <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
                <template slot-scope="scope">
                  {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
                </template>
              </el-table-column>
              <el-table-column prop="ApplicationDate" label="申请发放日" width="120" :show-overflow-tooltip="true" align="center">
                <template>{{baseInfo.ApplicationDate}}</template>
              </el-table-column>
              <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
                <template>{{baseInfo.ProjectName}} </template>
              </el-table-column>
              <el-table-column prop="CardId" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="EmployeeName" label="员工姓名" width="80" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="DepositBank" label="开户银行" width="80" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="BankAccount" label="银行帐号" width="80" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="DistributionChannel" label="发放途径" width="80" :show-overflow-tooltip="true" align="center">
                <template>{{baseInfo.PayrollChannel}} </template>
              </el-table-column>
              <el-table-column prop="ReleaseMode" label="发放方式" width="80" :show-overflow-tooltip="true" align="center">
                <!-- <template>{{baseInfo.PayType}} </template> -->
              </el-table-column>
              <el-table-column prop="Remark1" label="备注" width="150" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="IssuedThisMonth" label="本月实发" width="80" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="IncludesTelephoneSubsidy" label="包含电话费补贴的税前应发" width="180" align="center">
              </el-table-column>
              <el-table-column prop="OtherTaxDeductible" label="其中其他可避税项目" width="140" align="center">

              </el-table-column>
              <el-table-column prop="CommunicationCharge" label="其中通讯费" width="100" align="center">

              </el-table-column>
              <el-table-column prop="PersonalSupport" label="个人承担养老" width="100" align="center">

              </el-table-column>
              <el-table-column prop="PersonalCare" label="个人承担医疗" width="130" align="center">

              </el-table-column>
              <el-table-column prop="PersonalUnemployment" label="个人承担失业" width="130" align="center">

              </el-table-column>
              <el-table-column prop="BearCostSocialSecurity" label="个人承担社保费用" width="130" align="center">

              </el-table-column>
              <el-table-column prop="ProvidentFundCosts" label="个人承担公积金费用" width="140" align="center">

              </el-table-column>
              <el-table-column prop="IndividualIncomeTax" label="个人所得税" width="90" align="center">

              </el-table-column>
              <el-table-column prop="AbourUnionFees" label="工会费" width="80" align="center">

              </el-table-column>
              <el-table-column prop="DeductMealFee" label="扣餐费" width="80" align="center">

              </el-table-column>
              <el-table-column prop="CompanyDeductRentUtilities" label="企业扣房租水电" width="120" align="center">

              </el-table-column>
              <el-table-column prop="CompanyDeductsUtilities" label="公司扣房租水电" width="120" align="center">

              </el-table-column>
              <el-table-column prop="OtherDeductions" label="其他扣款（税后）" width="130" align="center">

              </el-table-column>
              <el-table-column prop="AdvanceWages" label="预支工资" width="100" align="center">
              </el-table-column>
              <el-table-column prop="DebitMoney" label="预支工资系统待核销余额" width="200" align="center">
              </el-table-column>

              <el-table-column prop="TotalAfterTaxDeductions" label="税后扣款合计" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="DecimalPointBalance" label="小数点差额调整（默认为正数）" width="210" align="center">

              </el-table-column>
              <el-table-column prop="TotalDeductible" label="扣除了所有费用的应扣合计" width="180" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="AmountSalaryPreviousMonth" label="当月历次发放工资金额首次工资额" width="220" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="AmountSalaryPreviousMonth2" label="当月历次发放工资金额二次工资额" width="220" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="AmountSalaryPreviousMonth3" label="当月历次发放工资金额三次工资额" width="220" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="AmountSalaryPreviousMonth4" label="当月历次发放工资金额四次工资额" width="220" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="ChildEducation" label="累计子女教育" width="100" align="center">

              </el-table-column>
              <el-table-column prop="ContinuingEducation" label="累计继续教育" width="100" align="center">

              </el-table-column>
              <el-table-column prop="HousingLoanInterest" label="累计住房贷款利息" width="130" align="center">

              </el-table-column>
              <el-table-column prop="AccumulatedHousingRent" label="累计住房租金" width="100" align="center">

              </el-table-column>
              <el-table-column prop="SupportElderlyCumulatively" label="累计赡养老人" width="100" align="center">

              </el-table-column>
              <el-table-column prop="CumulativeInfantCareCosts" label="累计婴幼儿照护费用" width="140" align="center">

              </el-table-column>
              <el-table-column prop="AccumulatedPersonalPension" label="累计个人养老金" width="120" align="center">

              </el-table-column>
              <el-table-column prop="PhoneNum" label="手机号码" width="120" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="EmploymentDay" label="用工之日" width="150" align="center">

              </el-table-column>
              <el-table-column prop="DischargeDate" label="离职日期" width="150" align="center">

              </el-table-column>
              <el-table-column prop="Remark1" label="备注" width="150" align="center">
              </el-table-column>
              <el-table-column prop="PayrollCompany" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="PersonalTaxIsBorne" label="税费承担方式" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="本年历月应税工资累计" width="155" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="累计应纳税所得额" width="130" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="累计应扣缴税额" width="120" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="累计已预缴税额" width="120" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <el-table-column prop="name" label="累计应补(退)税额" width="130" :show-overflow-tooltip="true" align="center">
              </el-table-column>
              <!-- <el-table-column prop="DebitMoney" label="未核销借支" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column> -->
              <el-table-column prop="IncludesTelephoneSubsidy" label="其他调整" width="100" align="center">

              </el-table-column>

              <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
              </el-table-column>
            </el-table>
          </div>
          <div class="block">
            <el-pagination v-if="totalcount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
          </div>
        </div>


        <el-table :data="tableData" border class="doc_table" v-if="dtlType=='预支工资'" style="width:100%;">
          <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="员工姓名" width="90" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="name" label="身份证号码" width="155" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="预支金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="实发金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="个税" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="是否在职" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="本月已预支金额" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="最近预支时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="发放途径" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="手机" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="发薪公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="人员校验" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="税局获取结果" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="120px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="readInfo(row)">人员信息查看</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="人员信息查看" :visible.sync="showRead" width="580px">
      <div class="readInfo" v-if="showRead">
        <div class="readInfoItem">姓名：{{info.EmployeeName}}</div>
        <div class="readInfoItem">身份证号码：{{info.CardId}}</div>
        <div class="readInfoItem">银行账号：{{info.BankAccount}}</div>
        <div class="readInfoItem">开户行：{{info.DepositBank}}</div>
        <div class="readInfoItem">手机号：{{info.PhoneNum}}</div>
        <div class="readInfoItem">发放方式：{{info.ReleaseMode}}</div>
        <div class="readInfoItem">用工之日：{{info.EmploymentDay}}</div>
        <div class="readInfoItem">离职日期：{{info.DischargeDate}}</div>
        <div class="readInfoItem">应发金额：{{info.IncludesTelephoneSubsidy}}</div>
        <div class="readInfoItem">发薪公司：{{info.PayrollCompany}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRead = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="人员信息修改" :visible.sync="showEdit" width="900px">
      <el-form :model="info" :inline="true" ref="editInfo" :rules="rules" label-width="100px" v-if="showEdit">
        <el-form-item label="姓名" prop="EmployeeName">
          <el-input v-model="info.EmployeeName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证号码" prop="CardId">
          <el-input v-model="info.CardId" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="应发金额" prop="IncludesTelephoneSubsidy">
          <el-input v-model="info.IncludesTelephoneSubsidy" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="银行帐号" prop="BankAccount">
          <el-input v-model="info.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="DepositBank">
          <el-input v-model="info.DepositBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="PhoneNum">
          <el-input v-model="info.PhoneNum" style="width:300px" size="small"></el-input>
        </el-form-item>
        <!-- <el-form-item label="发放方式" prop="PayType">
          <el-input v-model="info.PayType" style="width:300px" size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="用工之日" prop="EmploymentDay">
          <el-date-picker type="date" placeholder="" v-model="info.EmploymentDay" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="离职日期" prop="DischargeDate">
          <el-date-picker type="date" placeholder="" v-model="info.DischargeDate" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="发薪公司" prop="PayrollCompany">
          <el-input v-model="info.PayrollCompany" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          name: '',
          pageNum: 1,
          pageSize: 10,
          id: '',
          CardId: '',
          EmployeeName: '',
          BankAccount: '',
        },
        tableData: [{
          name: '666'
        }],
        activeName: 0,
        baseInfo: {},
        ApplySalaryExt: {
          SpecifyBankAccount: false,
          BankAccount: '',
        },
        showDropScreen: -1,
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        dtlType: '正常发薪', //明细类型  正常发薪/预支工资
        showBasicMore: false, //展开基本信息
        showPayMore: false, //展开客户到款信息
        showRead: false, //查看弹窗
        showEdit: false, //修改弹窗
        PaymentData: [],
        amountName: '可用金额',
        formData: {
          name: ''
        },
        index: '',
        info: {},
        rules: {
          name: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        isOver: false,
        fileList2: [],
        docHeadPath: this.$store.state.EMP.docPath,
        isExpLoading: false,
        isTaxExpLoading: false,
        dtlData: [],
        SummaryPersonnelDetails: {},
        type: '',
      }
    },
    created() {
      if (this.$route.query.Id != undefined && this.$route.query.Id) {
        this.listQuery.id = this.$route.query.Id;
        // this.dtlType = this.$route.query.type;
        this.type = this.$route.query.activeName;
      }
      this.getApplicationPayrollDetail();
    },
    methods: {
      checkPermission,
      getApplicationPayrollDetail() {
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.baseInfo = res.data.data;
            this.ApplySalaryExt = res.data.ApplySalaryExt;
            this.tableData = res.data.ApproveringList;
            // this.SummaryPersonnelDetails = res.data.SummaryPersonnelDetails;
            this.totalcount = res.data.totalcount;
            this.isOver = true;
            if (this.baseInfo.CustomerOriginalTableRul) {
              try {
                this.fileList2 = JSON.parse(this.baseInfo.CustomerOriginalTableRul)
              } catch (e) {
                this.fileList2 = [];
              }
            }
          } else {
            this.$message.error('获取详情出错')
            this.baseInfo = {};
            this.tableData = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //人员信息查看
      readInfo(row) {
        this.info = row;
        console.log(this.info)
        this.showRead = true;
      },
      //人员信息修改
      editInfo(row, index) {
        this.info = row;
        this.index = index;
        this.showEdit = true;
      },
      down(url) {
        var path = this.headPath + url;
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      confirmSubmit() {
        this.tableData[this.index] = this.info;
        // this.showEdit = false;
        let userList = [];
        userList.push(this.info)
        let data = {
          ApplySalary: this.baseInfo,
          userList: userList
        }
        xz.updataApplicationPayroll(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功！');
            this.getApplicationPayrollDetail();
            this.showEdit = false;
          } else {
            this.$message.error('系统出错')
          }
        })
      },

      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      changeTab() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        if (this.activeName == '0') {
          this.getApplicationPayrollDetail();
        } else {
          this.DailyInspectionWarrantyLapse();
        }
      },
      //获取原始数据
      DailyInspectionWarrantyLapse() {
        xz.getApplicationPayrollDetail(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            // this.baseInfo = res.data.data;
            this.dtlData = res.data.InitList;
            this.totalcount = res.data.InitCount;
            this.isOver = true;
            this.isloading = false;
          } else {
            this.$message.error('获取详情出错')
            this.isloading = false;
            this.totalcount = 0;
            // this.baseInfo = {};
            this.dtlData = []
          }
        })
      },
      //下载
      down2(url, head, name) {
        var path = head + url;
        const aTag = document.createElement('a')
        aTag.download = name //这里写保存时的名称
        aTag.href = path
        aTag.click();
      },
      del(row) {
        xz.delSsnDetail(row.Id).then((res) => {
          if (res.status == 'ok') {
            this.$message.success('删除成功');
            this.getApplicationPayrollDetail();
          } else {
            this.$message.error(res.msg);
            this.getApplicationPayrollDetail();
          }
        });
      },
      exportDtl() {
        let data = {
          Ids: this.baseInfo.Id,
          Type: '2'
        }
        this.isExpLoading = true;
        xz.payrollApplicationExport(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.baseInfo.ProjectName + this.baseInfo.IncomeTaxMonth + '明细列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExpLoading = false;
          } else {
            this.isExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      //导出算税明细
      exportTaxDtl() {
        this.isTaxExpLoading = true;
        xz.exportTaxCalcuResultDetail(this.baseInfo.Id, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.baseInfo.ProjectName + this.baseInfo.IncomeTaxMonth + '算税明细列表.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isTaxExpLoading = false;
          } else {
            this.isTaxExpLoading = false;
            this.$message.error(res.msg)
          }
        })
      },
      qqq() {
        let data = {
          bdate: '2024-03-09',
          edate: '2024-04-09',
          referenceNum: 'A001CB00202404081426274680000061',
          accountNo: ''
        }
        xz.getpayaccstr(data).then(res => {
          console.log(res)
        })
      },
      //获取到款信息
      getPaymentInfo() {
        if (!this.showPayMore) {
          if (this.type == '部分发薪' || this.type == '打款中' || this.type == '发薪失败') {
            this.amountName = '本批次核销金额'
            this.GetAssociatedClaimJson();
          } else {
            this.amountName = '可用金额'
            this.getClaimRecordList();
          }
        }
        this.showPayMore = !this.showPayMore;
      },
      getClaimRecordList() {
        let expandQuery = {
          ProjectIdStr: this.baseInfo.ProjectId,
          VestingMonth: this.baseInfo.AttrMonth,
          AccountName: this.baseInfo.Subject,
          pageNum: 1,
          pageSize: 10
        }
        xz.getClaimRecordList(expandQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.PaymentData = res.data.data;
          } else {
            this.PaymentData = [];
          }
        })
      },
      //本批次发薪认领金额使用明细
      GetAssociatedClaimJson() {
        let str = `?input=${this.listQuery.id}`
        xz.ArdCurStatGetFun('GetAssociatedClaimJson', str).then(res => {
          if (res.status == 'ok') {
            // 将 res.data 中的参数开头字母转为大写
            const capitalizedData = res.data.map(item => {
              const newItem = {};
              for (let key in item) {
                if (item.hasOwnProperty(key)) {
                  const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
                  newItem[capitalizedKey] = item[key];
                }
              }
              return newItem;
            });
            this.PaymentData = capitalizedData;
          } else {
            this.PaymentData = [];
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .showPaymentInfo {
    width: 1161px;
  }

  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .loongTxt {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 11em;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .demandForm .el-form-item__label {
    color: #999;
  }

  .page_salary .demandForm .el-form--inline .el-form-item {
    width: 270px;
    margin-right: 0;
  }

  .page_salary .demandForm .el-form-item {
    margin-bottom: 0;
  }

  .loongItem .el-form-item {
    width: 100% !important;
  }

  .loongItem .el-form-item__content {
    width: calc(100% - 200px)
  }
</style>